const ProjectReference = {
  LMS: '/LMS',
  Customer: '/Customer',
};

export default ProjectReference;
